/**
 * Single source of truth for the v3 flag <-> V4 capability-key mapping, so the
 * read path (mapV4DeviceToV3) and write path (AdminDevicePage saga) stay in sync.
 * V4 keys mirror the SDK's TwigConfigurationResponse.
 */

// v3 Device capability flag -> V4 capabilities map key.
export const V4_CAPABILITY_KEY_BY_FLAG = {
  srd: 'srd',
  ble: 'ble',
  wifi: 'wifi',
  gnss: 'gnss',
  threeG: '3g',
  fourG: '4g',
  voLTE: 'voLTE',
  md: 'manDown',
  ripcord: 'ripcord',
};

const CAPABILITY_FLAGS = Object.keys(V4_CAPABILITY_KEY_BY_FLAG);

// True when the V4 record carries this flag's key at all. Only Twigs ever get one
// written, so an absent key means "unknown", not "disabled".
export function isV4CapabilityKnown(capabilities, flag) {
  const key = V4_CAPABILITY_KEY_BY_FLAG[flag];
  if (!key || !capabilities) return false;
  return Object.prototype.hasOwnProperty.call(capabilities, key);
}

// Read shape is Record<string,string>; treat these (case-insensitive) as disabled,
// anything else present (true, "true", "1", "yes"...) as enabled.
const FALSY_TOKENS = new Set(['', 'false', '0', 'no', 'off', 'disabled', 'none', 'null', 'undefined']);

export function isV4CapabilityEnabled(value) {
  if (value === undefined || value === null) return false;
  return !FALSY_TOKENS.has(String(value).trim().toLowerCase());
}

// V4 `capabilities` map -> v3 Device flag booleans (every flag, defaulting false).
export function v4CapabilitiesToDeviceFlags(capabilities) {
  const caps = capabilities || {};
  const flags = {};
  CAPABILITY_FLAGS.forEach((flag) => {
    flags[flag] = isV4CapabilityEnabled(caps[V4_CAPABILITY_KEY_BY_FLAG[flag]]);
  });
  return flags;
}

// v3 Device flags -> V4 `capabilities` payload (Record<string, boolean>).
export function deviceToV4Capabilities(device) {
  const caps = {};
  CAPABILITY_FLAGS.forEach((flag) => {
    caps[V4_CAPABILITY_KEY_BY_FLAG[flag]] = !!device.get(flag);
  });
  return caps;
}
